/**
 * Visitor_offline mesajlarını toplu şekilde handle eder
 */

import { filter, bufferTime, map } from "rxjs/operators";
import store from "@/store";
import log2 from "../utils/log2";
import { systemMessageStream } from "../utils/systemPubSub";
import _ from "lodash";

const log = log2("liveVisitorsSyncWorker");

export const liveVisitorsSyncWorker = () => {
    log.info("liveVisitorsSyncWorker running");
    return systemMessageStream
        .pipe(
            filter((x) => ["new_visitor_connected", "visitor_offline"].includes(x.type)),
            map((x) => ({ ...x, ts: Date.now(), visitorId: x.payload.visitorId || x.payload.id })),
            bufferTime(3000),
            filter((messages) => messages.length > 0)
        )
        .subscribe((messages) => {
            const old = [...messages];
            const groups = _.orderBy(
                _.groupBy(messages, (q) => q.visitorId),
                ["ts"],
                "desc"
            );
            messages = Object.keys(groups).map((groupKey) => _.last(groups[groupKey]));
            log("liveVisitorsSyncWorker", { old, new: messages });
            const { connectedIds, disconnectedIds } = messages.reduce(
                (acc, cur) => {
                    if (cur.type === "new_visitor_connected") acc.connectedIds.push(cur.payload.visitorId);
                    else acc.disconnectedIds.push(cur.payload.id);

                    return acc;
                },
                {
                    connectedIds: [],
                    disconnectedIds: [],
                }
            );

            if (connectedIds.length) store.dispatch("visitor/batchAddLiveVisitor", connectedIds);
            if (disconnectedIds.length) store.dispatch("visitor/setMultiVisitorOffline", disconnectedIds);
        });
};
